//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;

//vanilla variables for resizing 
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

//header image to be window height on homepage
if(document.getElementsByClassName('img-slide').length > 0){
	let headerImages = document.getElementsByClassName('img-slide');
	let headerImagesLength = headerImages.length;
	for(let i = 0; i < headerImagesLength; i++){
		headerImages[i].style.height = (windowHeight + 10) + 'px';
	}
}
resizeWindow();


// Func = limiting Scope for this file
(function(){
	
	window.onload = function() {
		resizeWindow();
		scrollW();
	};

	window.addEventListener('scroll', function(){
		scrollW();
	})
	window.addEventListener('resize', function(){
		resizeWindow();
	});

	//scroll down click
	if(document.getElementsByClassName('scroll-down').length > 0){
		document.getElementsByClassName('scroll-down')[0].addEventListener('click', function(){
			animateTo('intro');
		});
	}
	document.getElementsByClassName('planning-btn')[0].addEventListener('click', function(e){
		e.preventDefault();
		animateTo(this.getAttribute('href').split('#')[1]);
	});

	//mobile burger menu
	document.getElementById('burgerMenu').addEventListener('click', function(){
		if(!this.classList.contains('open')){
			this.parentElement.classList.add('open');
			document.getElementById('mobile-nav-overlay').classList.add('open');
			document.getElementById('mobileNavClose').classList.add('open');
		}
	});

	document.getElementById('mobileNavClose').addEventListener('click', function(){
		if(this.classList.contains('open')){
			document.getElementById('burgerMenu').parentElement.classList.remove('open');
			document.getElementById('mobile-nav-overlay').classList.remove('open');		
			document.getElementById('mobileNavClose').classList.remove('open');		
		}
	});

	document.getElementById('tablet-planning-btn').addEventListener('click', function(){
		if(!document.getElementById('tabletForm').classList.contains('open')){
			document.getElementById('tabletForm').classList.add('open');	
			document.getElementById('innerTF').classList.add('open');	
		}
	});
	document.getElementById('closeTF').addEventListener('click', function(){
		if(document.getElementById('tabletForm').classList.contains('open')){
			document.getElementById('tabletForm').classList.remove('open');
			document.getElementById('innerTF').classList.remove('open');
		}
	});

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;

		if(st > 750){
			if (st > lastScrollTop){
				// downscroll code
				if(document.getElementById('home') && !document.getElementById('header').classList.contains('show-button')){
					// document.getElementById('header').classList.add('down');
					// document.getElementById('header').classList.remove('up');
					document.getElementById('header').classList.add('show-button');			
				}
			}
		} else {
			if(document.getElementById('home') && document.getElementById('header').classList.contains('show-button')){
				document.getElementById('header').classList.remove('show-button');
			}
		}
		if(st > 80){
			if (st > lastScrollTop){
				// downscroll code
				if(!document.getElementById('header').classList.contains('internal')){
					// document.getElementById('header').classList.add('down');
					// document.getElementById('header').classList.remove('up');
					document.getElementById('header').classList.add('internal');
					var logoUrl = site_url + 'assets/svg/hotelcontessa-logo-scroll.svg';
					document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
					
				}
			} else {
				
				
				// upscroll code
				// if(!document.getElementById('header').classList.contains('up')){
				// 	document.getElementById('header').classList.add('up');
				// 	document.getElementById('header').classList.remove('down');
				// 	document.getElementById('header').classList.remove('internal');
					
				// }
			}
		} else {
			if(document.getElementById('header').classList.contains('internal')){
				document.getElementById('header').classList.remove('internal');
					var logoUrl = site_url + 'assets/svg/contessa-logo-new-white.svg';
					document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
			}
			if(document.getElementById('gallery') && !document.getElementById('header').classList.contains('internal')){
				document.getElementById('header').classList.add('internal');
			}
			// if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			// 	document.getElementById('header').classList.remove('up');
			// 	document.getElementById('header').classList.remove('down');
			// 	if(document.getElementById('home') && windowWidth > 600) {
			// 		logoUrl = site_url + 'assets/svg/logo.svg';
			// 		document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
			// 	}
			// }
			
			// if(!document.getElementById('header').classList.contains('internal')){
				
			// 	document.getElementById('header').classList.add('internal');
			// }
		}
	
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	//header image to be window height on homepage
	if(document.getElementsByClassName('img-slide').length > 0){
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	}
	
	
}

//animation of scroll vanilla JS
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}